import Document from './document'
import Video from './video'
import Image from './image'
import Zip from './zip'

export default

	name: 'PressKitCard'

	functional: true

	props:
		card: Object

	# Render the appropriate component
	render: (create, { props: { card, type }, data }) ->

		# Make default data object
		data = {
			...data
			props: { card }
		}

		# Make cards
		if card.pressKitAsset[0]?
			switch card.pressKitAsset[0]?.mimeType
				when 'image/png' then create Image, data
				when 'image/jpeg' then create Image, data
				when 'video/mp4' then create Video, data
				when 'application/pdf' then create Document, data
				when 'application/zip' then create Zip, data

